import React from 'react';
import T from 'prop-types';
import { Link, IndexLink } from 'react-router';
import classnames from 'classnames/bind';
import 'whatwg-fetch'
import VisibilitySensor from 'react-visibility-sensor';
import { Auth } from './App.js'

// Using CSS Modules so we assign the styles to a variable
import s from './App.styl';
const cx = classnames.bind(s);

import pw from './pw';

// Favicon link is in the template, this just makes webpack package it up for us
import './favicon.ico';

import { isMobile, hashPass, store } from './utils'
const storage = store()

class Video extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
    this.load()
  }

  load () {
    let opts = {
      playsinline: false
    }
    if (isMobile) {
      opts.width = window.innerWidth
    } else {
      const offset = document.getElementById('single-header').offsetHeight +
                     document.getElementById('single-footer').offsetHeight +
                     30

      opts.height = window.innerHeight - offset
    }

    this.thePlayer = new Vimeo.Player(`video-${this.props.id}`, opts)
  }

  markAsPlayed () {
    let playedVideos = JSON.parse(storage.getItem('playedVideos') || '{}')
    playedVideos[this.props.id] = new Date().getTime()
    storage.setItem('playedVideos', JSON.stringify(playedVideos))
  }

  play () {
    this.load()
    this.markAsPlayed()
    this.thePlayer.on('play', () => {
      this.thePlayer.requestFullscreen()
    })
    this.thePlayer.on('fullscreenchange', ({ fullscreen }) => {
      if (!fullscreen) this.thePlayer.pause()
    })
  }

  render () {
    return (
      <div className={cx('main-video')}>
        <div
          id={`video-${this.props.id}`}
          data-vimeo-id={this.props.id}
          className={cx('video-player')}
        />
      </div>
    )
  }
}

class Header extends React.Component {
  render () {
    return (
      <div className={cx('single-header')} id='single-header'>
        <div className={cx('header-text')}>
          <h1>Stein Family</h1>
          <div className={cx('h2-background')}>
            <h2>Home Videos</h2>
          </div>
        </div>
      </div>
    )
  }
}

export class SingleVideo extends React.Component {
  static propTypes = {
    children: T.node,
  };

  constructor (props) {
    super(props)
    this.state = {}
  }

  onChange () {
    this.setState({
      thing: Math.random()
    })
  }

  componentDidMount () {
    setTimeout(() => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }, 500)
  }

  render() {
    const userPass = storage.getItem('password')
    // FOR BUiLD
    if (userPass == '__IS_BUILD__') {
      return (
        <div className={cx('page')}>
          <Header />
        </div>
      )
    }

    if (!userPass || hashPass(userPass) !== +pw) {
      return (
        <div className={cx('page')}>
          <Auth onChange={this.onChange.bind(this)} />
        </div>
      )
    }

    const { videoId } = this.props.params

    return (
      <div className={cx('single-video')}>
        <Header />
        <Video id={videoId} />
        <div className={cx('back-home')} id='single-footer'>
          <a className={cx('back-home-btn')} href='/'>&#8592; Back to all videos</a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/SingleVideo.js